<!-- clients -->
<div class="client_box">
    <h3 class="margin__bottom--200">Our Clients</h3>
    <div class="client_row">
        <collab-comp-button type="icon" [iconButtonConfig]="prevImageIconButtonConfig" (onBtnClick)="prevImage()"></collab-comp-button>
        <div class="client_images_container">
          <span *ngFor="let item of image; let i = index">
              <collab-comp-img-generator class="image_client" imageType="image" imgUrl="{{ item.src}}" *ngIf="i===currentIndex"></collab-comp-img-generator>
              <collab-comp-img-generator class="image_client" imageType="image" imgUrl="{{ item.src}}" *ngIf="i===currentIndex+1"></collab-comp-img-generator>
              <collab-comp-img-generator class="image_client" imageType="image" imgUrl="{{ item.src}}" *ngIf="i===currentIndex+2"></collab-comp-img-generator>
              <collab-comp-img-generator class="image_client" imageType="image" imgUrl="{{ item.src}}" *ngIf="i===currentIndex+3"></collab-comp-img-generator>
              <collab-comp-img-generator class="image_client" imageType="image" imgUrl="{{ item.src}}" *ngIf="i===currentIndex+4"></collab-comp-img-generator>
          </span>
        </div>
        <collab-comp-button type="icon" [iconButtonConfig]="nextImageIconButtonConfig" (onBtnClick)="nextImage()"></collab-comp-button>
    </div>
</div>

<!-- Client comments -->
<div class="container__comments--wrapper">
    <collab-comp-button type="icon" [iconButtonConfig]="prevCommentIconButtonConfig" (onBtnClick)="prevComment()"></collab-comp-button>
    <div class="container__comment-box--wrapper">
        <ng-container *ngFor="let data of comments; let i = index">
            <div *ngIf="i === currentComment" class="container__column--center--center">
                <div class="container__quotes">
                    <collab-comp-img-generator imageType="image" imgUrl="assets/icons/quotes.png" altText="quotes"></collab-comp-img-generator>
                    <div class="comments">{{ data.comment }}</div>
                </div>
                <div>
                    <div class="container__comment-name">
                        <div class="container__comment_image">
                            <collab-comp-img-generator imageType="image" imgUrl="{{ data.src }}" class="comment-image"></collab-comp-img-generator>
                        </div>
                        <h5 class="comments-name">{{ data.commenter_name }}</h5>
                        <p class="comments-name">{{ data.commenter_designation }}</p>
                    </div>
                    <div class="name_box"></div>
                </div>
            </div>
        </ng-container>
    </div>
    <collab-comp-button type="icon" [iconButtonConfig]="nextCommentIconButtonConfig" (onBtnClick)="nextComment()"></collab-comp-button>
</div>
